import { faArrowLeft } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "react-bootstrap";
import React, { useContext, useEffect, useState } from "react";
import { Link, withRouter } from "react-router-dom";
import { ROUTES } from "../../utils";
import InnerLayoutButtons from "../InnerLayoutButtons";
import LoaderWrapper from "../LoaderWrapper";

const ManagePayrollTabLayout = ({
  label,
  isLoading = false,
  step,
  noStep = false,
  buttons = [],
  onClick,
  children,
  returnArrow = false,
  onReturnArrowClick,
  isCensusPayrollPage = false,
  onPayrollDeleteClick,
  displayTitle = true,
  labelrequired = true,
  payrollId,
  headerSpace = true,
  className1,
  isAllowedUpdate = false,
  isAllowedDelete = false,
}) => {
  return (
    <LoaderWrapper
      isLoading={isLoading}
      className={className1 ? `${className1}` : " pr-4 mt-2 "}
    >
      {displayTitle && (
        <div className="d-flex justify-content-space-between  manage-payroll-tab-layout-header">
          {returnArrow && (
            <div className="mt-2">
              <FontAwesomeIcon
                icon={faArrowLeft}
                onClick={onReturnArrowClick}
                size="500px"
                color="blue"
                // onClick={() => {
                //   setErrorPage(false);
                // }}
              />
            </div>
          )}
          <p className="d-flex mt-2">
            {noStep ? "" : <span className="grey-text">Step {step} :</span>}{" "}
            {labelrequired && <h5 className="font-weight-500 ml-2">{label}</h5>}
          </p>
          <div className="ml-auto">
            {isCensusPayrollPage ? (
              <div className="d-flex">
                {isAllowedDelete && (
                  <span
                    type="submit"
                    style={{ color: "red", marginTop: "16px" }}
                    onClick={() => {
                      onPayrollDeleteClick();
                    }}
                  >
                    <i className="fa fa-trash-alt mr-2" />
                    Delete Record
                  </span>
                )}
                {isAllowedUpdate && (
                  <div className="p-2 ml-3">
                    <Button
                      type="submit"
                      variant="primary"
                      onClick={() => onClick()}
                    >
                      Submit
                    </Button>
                  </div>
                )}
              </div>
            ) : (
              <InnerLayoutButtons
                menu="payroll"
                buttonsList={buttons}
                // flow={pageFlow}
              />
            )}
          </div>
        </div>
      )}
      {step && step !== 3 && <hr style={{ width: "100%", marginTop: "0px" }} />}
      <div
        className="layout-content"
        style={{
          //height: "100%",
          //overflowX: "hidden",
          height: "auto",
        }}
      >
        {children}
      </div>
    </LoaderWrapper>
  );
};

export default withRouter(ManagePayrollTabLayout);
